/**
 * useCard hook.
 */
import HorizontalCard from '@components/elements/card/ui/cards/horizontalCard';
import SettingCard from '@components/elements/card/ui/cards/settingCard';
import { GridDisplayMode } from '@shared/types/enums/grid';

/**
 * Hook for the grid card component. Based on the grid display mode, it returns the appropriate card component.
 */
export default function useCard(displayMode?: GridDisplayMode) {
  let Card = HorizontalCard;
  switch (displayMode) {
    case GridDisplayMode.SETTING:
      Card = SettingCard;
      break;
    case GridDisplayMode.PHOTO:
    default:
      Card = HorizontalCard;
      break;
  }
  return { Card };
}
